import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circleCheckMark",
  "use": "circleCheckMark-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"transparent\" id=\"circleCheckMark\">\n\t<circle cx=\"10\" cy=\"10\" r=\"9.25\" transform=\"rotate(-90 10 10)\" stroke=\"currentColor\" stroke-width=\"1.5\" />\n\t<path d=\"M6.6665 11.146L9.30703 13.3335L13.3332 8.3335\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"square\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol